import { Box, type BoxProps, Paper } from '@mui/material';
import type { FunctionComponent } from 'react';
import { TOP_BANNER_HEIGHT } from '../../constants/general';

export const ModernePaperBox: FunctionComponent<BoxProps> = ({
  children,
  ...rest
}) => (
  <Paper variant="outlined">
    <Box
      {...rest}
      sx={[{ m: 2 }, ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx])]}
    >
      {children}
    </Box>
  </Paper>
);

export const StickyBox: FunctionComponent<
  { top?: number | number[] } & BoxProps
> = ({ children, sx, top = TOP_BANNER_HEIGHT, ...rest }) => {
  return (
    <Box
      sx={{
        position: 'sticky',
        zIndex: (theme) => theme.zIndex.appBar,
        marginBottom: 1,
        top,
        ...sx
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};
